import React, {useEffect, useState} from 'react';
import {useTable, useGlobalFilter, useFilters, usePagination} from 'react-table';
import './../FilteringTable/filtering.css';
import {columns_notification} from "../FilteringTable/NotificationTabelsColumns";
import {
    fetchAllNotificationsCall,
    startSendingNotificationCall
} from "../../Api/ApiCalls";
import {toast} from "react-toastify";
import {toastOptions} from "../../config/Constants";
import {ApiSearchField} from "../ApiSearchField";
import swal from "sweetalert";
import Swal from "sweetalert2";
import NotificationDetailModal from './NotificationDetailModal';
import {Link} from "react-router-dom";


export default function AllNotification() {
    const [data, setData] = useState([])
    const [totalPages, setTotalPages] = useState(undefined);
    const [currentPage, setCurrentPage] = useState(undefined);
    const [columns, setColumns] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [notificationDetails, setNotificationDetails] = useState(undefined)
    const [notificationSegmentation, setNotificationSegmentation] = useState(undefined)
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        setColumns(columns_notification)
    }, []);

    useEffect(() => {
        fetchAllNotifications(1);
    }, [searchQuery]);


    const tableInstance = useTable({
        columns,
        data,
        initialState: {pageIndex: 0}
    }, useFilters, useGlobalFilter, usePagination)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        state,
        page,
    } = tableInstance


    const {pageIndex} = state

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h4 className="card-title">Notifications</h4>
                    <div className="d-flex gap-2">
                        <Link to={"/new-notification"} className="btn btn-secondary">+ New Notification</Link>
                        <Link to={"/notification-templates"} className="btn btn-outline-secondary">Templates</Link>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <ApiSearchField
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                        />
                        <table {...getTableProps()} className="table dataTable display">
                            <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th style={{ width: column.width }}>
                                            {column.render('Header')}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>

                            {page.map((row) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()} >
                                        {row.cells.map((cell) => {
                                            return <td {...cell.getCellProps()} className="cursor-pointer"
                                                       onClick={() => openModalShow(row.original)}> {cell.render('Cell')} </td>

                                        })}
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-between">
              <span>
                Page{" "}
                  <strong>
                  {currentPage} of {totalPages}
                </strong>
                  {""}
              </span>
                            <span className="table-index d-none">
                Go to page :{" "}
                                <input
                                    type="number"
                                    className="ml-2"
                                    defaultValue={pageIndex + 1}
                                    onChange={(e) => {
                                        const pageNumber = e.target.value
                                            ? Number(e.target.value)
                                            : 1;
                                        fetchAllNotifications(pageNumber);
                                    }}
                                />
              </span>
                        </div>
                        <div className="text-center mb-3">
                            <div className="filter-pagination  mt-3">
                                <button
                                    className=" previous-button"
                                    onClick={() => fetchAllNotifications(1)}
                                    disabled={currentPage === 1}
                                >
                                    {"<<"}
                                </button>

                                <button
                                    className="previous-button"
                                    onClick={() => fetchAllNotifications(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    Previous
                                </button>
                                <button
                                    className="next-button"
                                    onClick={() => fetchAllNotifications(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                                <button
                                    className=" next-button"
                                    onClick={() => fetchAllNotifications(totalPages)}
                                    disabled={currentPage === totalPages}
                                >
                                    {">>"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <NotificationDetailModal
                show={showModal}
                onHide={() => setShowModal(false)}
                notification={notificationDetails}
                segmentation={notificationSegmentation}
                onStartSending={startSendingANotification}
                showActionButtons={true}
            />
        </>
    )

    function openModalShow(item) {
        setShowModal(true)
        setNotificationDetails(item)
        setNotificationSegmentation(item?.segmentationCriteria)
    }

    async function startSendingANotification() {
        const confirmation = await swal({
            title: "Are you sure?",
            text: `You want to send this notification to ${notificationDetails.totalReceivers} users`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });
        if (!confirmation) return;
        try {
            Swal.fire({
                title: "Loading...",
                allowOutsideClick: true,
                allowEscapeKey: false,
                showConfirmButton: false,
                icon: "info",
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
            await startSendingNotificationCall(notificationDetails.id);
            toast.success('The Notification was sent successfully', toastOptions);
        }catch (error) {
            toast.warn(error.message || 'Failed to send notification. Please try again.', toastOptions);
        }finally {
            Swal.close();
        }


    }
    function getFilters() {
        const apiFilters = [];
        if (searchQuery?.length) {
            apiFilters.push(`q=${encodeURIComponent(searchQuery)}`);
        }
        return apiFilters.join("&");
    }

    function fetchAllNotifications(page) {
        fetchAllNotificationsCall(page, 10, getFilters()).then(result => {
            setData(result?.items);
            setTotalPages(result.totalPages);
            setCurrentPage(result.page);
        }).catch(error => {
            toast.error(error.response.data.error, toastOptions)
        })
    }
}
